import React from "react";
import {Category, Menu} from "@/data/entities/menu";
import {Badge, ButtonGroup, ButtonGroupButton} from "peggirkit";

type Props = {
    menu: Menu,
    isFetching: boolean,
};

const CategoriesList = ({menu, isFetching}: Props) => {
    return (
        <ButtonGroup
            vertical
            variant={"solid"}
            containerClassName={"w-full"}
        >
            {menu.categories.map((category: Category) =>
                <ButtonGroupButton
                    key={category.id}
                    disabled={isFetching}
                    buttonAction={{
                        as: "button",
                        actionProps: {
                            onClick: e => {
                                e.preventDefault();
                                if (!isFetching) {
                                    document
                                        .querySelector(`li[data-category-id="${category.id}"]`)
                                        ?.scrollIntoView({behavior: "smooth"});
                                }
                            }
                        },
                    }}
                >
                    {category.name}
                    <Badge
                        size={"xs"}
                        radius={"chip"}
                        containerClassname={"absolute right-4 top-1/2 -translate-y-1/2"}
                    >
                        {category.productIds.length}
                    </Badge>
                </ButtonGroupButton>
            )}
        </ButtonGroup>
    );
};

export default CategoriesList;